import { httpClient } from '@shared/api';
import type { AuthResponse } from '@entities/user';

/**
 * Все auth-эндпоинты бэка richat-next.
 * Соответствует richat_backend/api/routers/auth.py.
 */
export const authApi = {
  // ---- Регистрация по email ----

  async register(payload: { email: string; password: string }): Promise<void> {
    await httpClient.post('/auth/email/register', payload);
  },

  async verify(payload: { email: string; code: string }): Promise<AuthResponse> {
    const response = await httpClient.post<AuthResponse>('/auth/email/verify', payload);
    return response.data;
  },

  // ---- Вход ----

  async login(payload: { email: string; password: string }): Promise<AuthResponse> {
    const response = await httpClient.post<AuthResponse>('/auth/email/login', payload);
    return response.data;
  },

  // ---- Восстановление пароля ----

  async requestPasswordReset(payload: { email: string }): Promise<void> {
    await httpClient.post('/auth/email/password-reset/request', payload);
  },

  async confirmPasswordReset(payload: {
    email: string;
    code: string;
    new_password: string;
  }): Promise<void> {
    await httpClient.post('/auth/email/password-reset/confirm', payload);
  },

  // ---- Сессия ----

  async refresh(): Promise<AuthResponse> {
    const response = await httpClient.post<AuthResponse>('/auth/refresh');
    return response.data;
  },

  async logout(): Promise<void> {
    await httpClient.delete('/auth/');
  },
};
